import React from "react";
import useLanguage from "../../hooks/language";
import styles from "./breadcrumbs.module.css";

interface BreadcrumbsProps {
    currentIndex?: number;
    crumbTitles: string[];
}

const Breadcrumbs: React.FunctionComponent<BreadcrumbsProps> = ({
    currentIndex = 0,
    crumbTitles,
}: BreadcrumbsProps) => {
    const { translations } = useLanguage();
    // Rendering
    const breadCrumbItems = crumbTitles.map((crumb, index) => {
        const isActive = index === currentIndex;
        return (
            <li
                aria-label={`${translations.breadcrumb.step} ${
                    index + 1
                }: ${crumb}`}
                aria-current={isActive ? "step" : undefined}
                title={crumb}
                key={`crumb-item-${index}`}
                className={`${styles.breadcrumbListItem} ${
                    isActive ? styles.breadcrumbListItemActive : ""
                }`}
            >
                <span aria-hidden="true">{index + 1}</span>
            </li>
        );
    });
    return (
        <ol
            aria-label={translations.breadcrumb.title}
            className={styles.breadcrumbList}
        >
            {breadCrumbItems}
        </ol>
    );
};

export default Breadcrumbs;
